import CardSlider from './card-slider';

export default CardSlider;